module.exports = __webpack_public_path__ + "img/lighting.6c5ce9d3.png";